import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

export const FullScreenLoadingOverlay: React.FC<{ loading: boolean }> = ({
  loading,
}) => (
  <Backdrop
    open={loading}
    classes={{ root: "scd-loader" }}
    sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1 })}
  >
    <CircularProgress className="scd-loader-spinner" />
  </Backdrop>
);
